import { compose, withHandlers } from 'recompose';

import { sendCommunicationClick } from '../../core/services/tracking';
import CommunicationBox from './CommunicationBox';

const configureHandlers = withHandlers({
  handleClick: ({ funnelId }) => (posName, type) => {
    sendCommunicationClick(posName, type, funnelId);
  },
});

export default compose(configureHandlers)(CommunicationBox);
